import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "knowledge-base-delete-modal";

const keys = addTranslations(RESOURCE_NAME, {
    delete_custom_item_modal_title: {
        en: "Delete Custom Item",
        fr: "Supprimer l'information spécifique",
    },
    delete_custom_item_modal_body: {
        en: "Are you sure you want to delete this custom item? This action is irreversible.",
        fr: "Êtes-vous sûr de vouloir supprimer cette information spécifique ? Cette action est irréversible.",
    },
    delete_custom_item_modal_cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
    delete_custom_item_modal_confirm_button: {
        en: "Delete",
        fr: "Supprimer",
    },
});

export function useKnowledgeBaseDeleteModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
